/**
 * 일지 유형의 모양
 * ---------------------------------------------------------------------------
 * 메뉴·대시보드 달력·차트가 같은 아이콘과 색을 쓴다. 곳마다 다르면 달력의
 * 파란 점이 어느 일지인지 사용자가 매번 범례를 봐야 한다.
 *
 * 색은 서로 잘 구분되고 색각 이상에서도 명도로 갈리는 세 가지를 골랐다.
 */

import type { ReactNode } from 'react';
import { CloudOutlined, ExperimentOutlined, FileTextOutlined } from '@ant-design/icons';
import type { LogType } from '@eco/shared';

export const LOG_TYPE_ICON: Record<LogType, ReactNode> = {
  T01_AIR: <CloudOutlined />,
  T02_WATER_CONSIGN: <FileTextOutlined />,
  T03_WATER_SELF: <ExperimentOutlined />,
};

export const LOG_TYPE_COLOR: Record<LogType, string> = {
  T01_AIR: '#1677ff',
  T02_WATER_CONSIGN: '#0f7b6c',
  T03_WATER_SELF: '#d46b08',
};
